import React from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import IUpdate from 'icons/IUpdate';

export type DeleteButtonProps = ButtonProps & {
  onlyIcon?: boolean;
};

const ConvertButton = ({
  children = 'Convert',
  onlyIcon = false,
  ...otherProps
}: DeleteButtonProps) => {
  return (
    <Button
      icon={<IUpdate color="#00a896" height="16px" width="13px"/>}
      style={{
        height: 40,
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 5,
      }}
      {...otherProps}
    >
      {!onlyIcon ? children : null}
    </Button>
  );
};

export default ConvertButton;
